import type { ID } from "@constants";
import { useCancelAppointmentFunc } from "@components/organisms/appointmentCard/components/appointmentHelper/cancelAppointment";
import { useDeclineAppointmentFunc } from "@components/organisms/appointmentCard/components/appointmentHelper/declineAppointment";
import { useAcceptAppointmentFunc } from "@components/organisms/appointmentCard/components/appointmentHelper/acceptAppointment";
import { useNoShowAppointmentFunc } from "@components/organisms/appointmentCard/components/appointmentHelper/noShowAppointment";
import { useCommentAppointmentFunc } from "@components/organisms/appointmentCard/components/appointmentHelper/commentAppointment";

export const useAppointmentHelper = (id: ID) => {
  const cancel = useCancelAppointmentFunc(id);
  const decline = useDeclineAppointmentFunc(id);
  const accept = useAcceptAppointmentFunc(id);
  const noShow = useNoShowAppointmentFunc(id);
  const comment = useCommentAppointmentFunc(id);

  const appointmentHelper = {
    cancel,
    decline,
    accept,
    noShow,
    comment,
  };

  return { appointmentHelper };
};
